class MemberChangeLogs
  constructor: ->
    @_bind()

  _bind: ->
    $el = $('.project-member-change-logs')
    $el.on 'click', '.link-logs-more', ->
      $el.find('.log-item.hide').removeClass 'hide'
      $(@).remove()


tower.memberChangeLogs = ->
  new MemberChangeLogs
